import { API } from '.'
import { handleResponse, handleLoginResponse } from '../helpers';
import { API_URL } from '../config/appConfig';
import { accountLinkingConstants } from '../constants';

const systemUserLogin = async (username, password) => {
    return API.post(`${API_URL.idpAuth}/system/auth/login`, "login", { username, password })
        .then(handleLoginResponse)
}

const systemUserLogout = () => {
    return API.post(`${API_URL.idp}/system/auth/logout`, "logout", {})
        .then(handleResponse)
        .then(() => ({}))
}

const tenantUserLogin = async (username, password, clientId) => {
    return API.post(`${API_URL.idpAuth}/auth/login`, "login", {
        username,
        password,
        clientId,
    }).then(handleLoginResponse)
}

const tenantUserLogout = () => {
    return API.post(`${API_URL.idp}/auth/logout`, "logout", {})
        .then(handleResponse)
        .then(() => ({}))
}

const getAccountLinkingAuthToken = (username, password, clientId, responseType, redirectURL) => {
    const reqBody = {
        password,
        clientId,
        responseType,
        redirectUrl: redirectURL,
    }

    if (username.includes('@')) {
        reqBody.email = username
    } else {
        reqBody.mobile = username
    }

    return API.post(`${API_URL.idpAuth}/oauth2/login`, accountLinkingConstants.API_KEY, reqBody)
        .then((res) => handleResponse(res, true))
}

const getAccountLinkingAuthCode = (scope, accepted, authorizationToken) => {
    return API.post(`${API_URL.idpAuth}/oauth2/authcode`, accountLinkingConstants.API_KEY, {
        scope,
        accepted,
    }, {
        headers: {
            Authorization: `Bearer ${authorizationToken}`,
        },
    }).then((res) => handleResponse(res, true))
}

const registerUser = (payload) => {
    return API.post(
        `${API_URL.idpAuth}/user/register`,
        "register_user",
        payload
    ).then((res) => handleResponse(res, true))
}

const resetPassword = (payload) => {
    return API.post(
        `${API_URL.idpAuth}/auth/resetPassword`,
        "reset_password",
        payload
    ).then((res) => handleResponse(res, true))
}

export const userService = {
    systemUserLogin,
    systemUserLogout,
    tenantUserLogin,
    tenantUserLogout,
    getAccountLinkingAuthToken,
    getAccountLinkingAuthCode,
    registerUser,
    resetPassword,
}
